import axios from "axios";
import Vue from "vue";

const instance = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
});

let requestCount = 0;

function showLoader() {
  if (requestCount === 0) {
    Vue.prototype.$loading(true);
  }
  requestCount++;
}

function hideLoader() {
  requestCount--;
  if (requestCount === 0) {
    Vue.prototype.$loading(false);
  }
}

// Interceptor para solicitudes
instance.interceptors.request.use(
  (config) => {
    // Las peticiones automáticas/recurrentes pueden marcar
    // `skipLoader: true` para no mostrar el loader global.
    if (!config.skipLoader) {
      showLoader();
    }
    return config;
  },
  (error) => {
    if (!(error.config && error.config.skipLoader)) {
      hideLoader();
    }
    return Promise.reject(error);
  }
);

// Interceptor para respuestas
instance.interceptors.response.use(
  (response) => {
    if (!(response.config && response.config.skipLoader)) {
      hideLoader();
    }
    return response;
  },
  (error) => {
    if (!(error.config && error.config.skipLoader)) {
      hideLoader();
    }
    return Promise.reject(error);
  }
);

export default instance;
